import { render, staticRenderFns } from "./RequestHeader.vue?vue&type=template&id=420d1061"
import script from "./RequestHeader.vue?vue&type=script&lang=ts"
export * from "./RequestHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420d1061')) {
      api.createRecord('420d1061', component.options)
    } else {
      api.reload('420d1061', component.options)
    }
    module.hot.accept("./RequestHeader.vue?vue&type=template&id=420d1061", function () {
      api.rerender('420d1061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/requests/RequestHeader.vue"
export default component.exports